module.exports = __webpack_public_path__ + "img/253be81.png";